module.exports = __webpack_public_path__ + "img/avatar_random_12.026bc6c9.png";